import { generateAclObjectFormEnv } from 'src/utils/envHelpers'

const ACLS = {
  ...generateAclObjectFormEnv(),
}

export default ACLS
